<template>
  <div class="app-container">
    <div v-loading="loading">
      <el-tabs
        tab-position="left"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <template v-for="(item, i) in fireTipData">
          <el-tab-pane :key="i" :label="item.title" :name="i + ''">
            <five
              
              :device-list="deviceList"
              :text="item.title"
            />
          </el-tab-pane>
        </template>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { selectElectricity } from '@/api/business/base/tenant/map'

import Five from './component/five'
export default {
  components: {
    Five
  },
  data() {
    return {
      activeName: '0',
      deviceAllList: [],
      deviceList: [],
      loading: false,
      fireTipData: [
        {
          title: 'AA1-AA3',
          deviceIds: [28340, 28348],
          textList: ['100/5', '75/5', '100/5', '100/5', '200/5', '400/5', '100/5', '50/5', '300/5'],
        },
        {
          title: 'AA4-AA6',
          deviceIds: [28349, 28361],
          textList: ['100/5', '100/5', '100/5'],
        },
        {
          title: 'AA7-AA8',
          deviceIds: [28362, 28373],
          textList: ['150/5', '150/5', '400/5', '400/5', '50/5', '400/5', '400/5'],
        },
        {
          title: 'AA9-AA11',
          deviceIds: [28374, 28382],
          textList: ['100/5', '300/5', '100/5', '100/5', '100/5', '100/5'],
        },
        {
          title: 'AH1-AH6',
          deviceIds: [26736, 26739],
          textList: ['250/5', '250/5', '200/5', '50/5'],
        }
      ]
    };
  },
  created() {
    if (this.$route.query.index) {
      this.activeName = this.$route.query.index
    }
    this.loading = true
    selectElectricity({ categoryId: 19, positionParentId: 36 }).then(res => {
      this.deviceAllList = res
    }).then(() => {
      const minId = this.fireTipData[+this.activeName].deviceIds[0]
      const maxId = this.fireTipData[+this.activeName].deviceIds[1]
      const obj = this.deviceAllList.filter(k => k.deviceId >= minId && k.deviceId <= maxId)
      this.deviceList = obj.sort(this.sortNumber)

    }).then(() => {
      this.loading = false
    }).catch(() => {
      this.loading = false
    })

  },
  methods: {
    // 排序
    sortNumber(a, b) {
      return +a.deviceId - +b.deviceId
    },
    handleClick() {
      this.deviceList = []
      const minId = this.fireTipData[+this.activeName].deviceIds[0]
      const maxId = this.fireTipData[+this.activeName].deviceIds[1]
      const obj = this.deviceAllList.filter(k => k.deviceId >= minId && k.deviceId <= maxId)
      this.deviceList = obj.sort(this.sortNumber)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  width: 2140px;
}
.el-tabs {
  background-color: #ffffff;
}
</style>